module.exports = __webpack_public_path__ + "img/D202309_3.325a70ba.jpg";